<template>
    <b-container fluid>
      <b-row v-if="noSpecs">
        <b-col>
            No hay especificaciones para seleccionar.
        </b-col>
      </b-row>
      <div v-for="info in props" :key="info.name">
        <b-row v-if="info.value.specificationFieldValues.length > 0" class="mt-3 attr-row">
          <b-col md="6">
            <b-form-group
                v-if="['Texto', 'Texto Grande', 'Texto Indexado', 'Texto Grande Indexado'].includes(info.spec.specificationFieldType.fieldTypeName)"
                :label-cols="4"
                :description="info.spec.description"
                :label="info.spec.name"
                :invalid-feedback="!isValidText(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired)) && !disabled? `El atributo ${info.spec.name} es inválido`: ''"
                :state="isValidText(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired))"
            >
                <b-form-input
                  v-if="['Texto', 'Texto Grande', 'Texto Indexado', 'Texto Grande Indexado'].includes(info.spec.specificationFieldType.fieldTypeName)"
                  v-model="info.value.specificationFieldValues[0].value"
                  :disabled="disabled"
                  >
                </b-form-input>
              </b-form-group>

              <b-form-group
                v-if="info.spec.specificationFieldType.fieldTypeName === 'Número'"
                :label-cols="4"
                :description="info.spec.description"
                :label="info.spec.name"
                :invalid-feedback="!isValidInteger(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired))? `El atributo ${info.spec.name} es inválido`: ''"
                :state="isValidInteger(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired))"
            >
                <b-form-input
                  v-if="info.spec.specificationFieldType.fieldTypeName === 'Número'"
                  v-model="info.value.specificationFieldValues[0].value"
                  :disabled="disabled"
                  type="number"
                  >
                </b-form-input>
            </b-form-group>
            <b-form-group
                v-if="info.spec.specificationFieldType.fieldTypeName === 'Combo'"
                :label-cols="4"
                :description="info.spec.description"
                :label="info.spec.name"
                :invalid-feedback="info.value.isRequired && !Boolean(Object.keys(info.value.specificationFieldValues[0]).length) && !disabled ? ` ${info.spec.name} es obligatorio`: ''"
                :state="info.value.isRequired && Boolean(Object.keys(info.value.specificationFieldValues[0]).length)"
              >
                <b-form-select
                  v-model="info.value.specificationFieldValues[0]"
                  :options="convertToOptions(info.spec.specificationFieldValues)"
                  :disabled="disabled">
                </b-form-select>
              </b-form-group>

              <b-form-group
                  v-if="info.spec.specificationFieldType.fieldTypeName === 'Radio'"
                  :label-cols="4"
                  :description="info.spec.description"
                  :label="info.spec.name"
                  :invalid-feedback="info.value.isRequired && !Boolean(Object.keys(info.value.specificationFieldValues[0]).length) && !disabled ? `El atributo ${info.spec.name} es obligatorio`: ''"
                  :state="info.value.isRequired && Boolean(Object.keys(info.value.specificationFieldValues[0]).length)"
                >
                <b-form-radio-group
                  v-model="info.value.specificationFieldValues[0]"
                  :options="convertToOptions(info.spec.specificationFieldValues)"
                  :disabled="disabled">
                </b-form-radio-group>
              </b-form-group>

              <b-form-group
                    v-if="info.spec.specificationFieldType.fieldTypeName === 'CheckBox'"
                    :label-cols="4"
                    :description="info.spec.description"
                    :label="info.spec.name"
                    :invalid-feedback="info.value.isRequired && !Boolean(Object.keys(info.value.specificationFieldValues[0]).length) && !disabled ? `El atributo ${info.spec.name} es obligatorio`: ''"
                    :state="info.value.isRequired && Boolean(Object.keys(info.value.specificationFieldValues[0]).length)"
                  >
                  <b-form-checkbox-group
                    v-model="info.value.specificationFieldValues[0]"
                    :options="convertToOptions(info.spec.specificationFieldValues)"
                    :disabled="disabled"
                  ></b-form-checkbox-group>
              </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-container>
</template>

<script>

import { ProductServiceMixim } from '@/mixims/ProductServiceMixim'
import { ValidationsMixim } from '@/mixims/ValidationsMixim.js'

export default {
  name: 'product-attributes',
  mixins: [ProductServiceMixim, ValidationsMixim],
  props: ['mergedInfo', 'disabled'],
  watch: {
    mergedInfo: function (newVal, oldVal) {
      this.props = newVal
    }
  },
  data () {
    return {
      props: null
    }
  },
  computed: {
    noSpecs () {
      // There are no specifications if props is null or undefined
      if (!this.props) {
        return true
      }

      // There are no specifications if props is an empty array
      if (this.props.length === 0) {
        return true
      }

      // There are no specifications if all props have no specificationFieldValues
      if (this.props.length > 0) {
        return this.props.every(info => info.value.specificationFieldValues.length === 0)
      }
    }
  },
  methods: {
    convertToOptions (specificationFieldValues) {
      return specificationFieldValues.map(sfv => {
        return {text: sfv.value, value: sfv}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .attr-row {
    border: 1px solid #CCCCCC;
    border-radius: 10px;
    padding: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/catalog/ProductAttributes.vue